export function onNextFrame(callback: FrameRequestCallback) {
  setTimeout(() => requestAnimationFrame(callback));
}
